import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://dghzodfimkmsuaikltlc.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRnaHpvZGZpbWttc3VhaWtsdGxjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxMzUwNTcsImV4cCI6MjA3MTcxMTA1N30.Nvgmihm9ufQwR1Ecc8K91oJJiGguzkpIopQQlTMaf8Y'

if (supabaseUrl === 'https://<PROJECT-ID>.supabase.co' || supabaseKey === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables')
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})